// extracted by mini-css-extract-plugin
export default {"container":"EventsGroup_container__GxfNF","btnGroup":"EventsGroup_btnGroup__8hmki"};